<template>
<div class='content'>
  <div class="result">
    <img class="success-icon" src="@static/images/fail.png" alt="">
    <div class="text">请在企业微信内打开当前链接</div>
  </div>
</div>
</template>
<script>
export default {
data:()=>({
}),
components:{
},
created(){
},
methods:{
}
}
</script>
<style lang='scss' scoped>
.content{
  padding: r(30);
  min-height: 100vh;
  background: #FFFFFF;
   .result{
    text-align: center;
    .success-icon{
      padding-top: r(110);
      width: r(110);
      height: r(110);
    }
    .text{
      margin-top: r(20);
      font-size: r(40);
      font-weight: 700;
      line-height: r(34);
      color: #333333;
    }
  }
}
</style>